<template>
  <div class="dashboard-container">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card class="dashboard-card">
          <div slot="header" class="clearfix">
            <span>Welcome</span>
          </div>
          <div class="card-content">
            <p>Welcome, user <b>{{ userInfo.username }}</b></p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="dashboard-card">
          <div slot="header" class="clearfix">
            <span>Your Roles</span>
          </div>
          <div class="card-content">
            <p v-for="role in roles" :key="role">{{ role }}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="dashboard-card">
          <div slot="header" class="clearfix">
            <span>Your Permissions</span>
          </div>
          <div class="card-content">
            <p v-for="permission in permissions" :key="permission">{{ permission }}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="dashboard-card">
          <div slot="header" class="clearfix">
            <span>Todos</span>
          </div>
          <div class="card-content">
            <p>TODO1</p>
            <p>TODO2</p>
            <p>TODO3</p>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: this.$store.state.user ? this.$store.state.user.userInfo : {},
      roles: this.$store.state.user ? this.$store.state.user.roles : [],
      permissions: this.$store.state.user ? this.$store.state.user.permissions : []
    };
  }
};
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}

.dashboard-card {
  margin-bottom: 20px;
}

.card-content {
  min-height: 150px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue